import { Link } from 'react-router-dom';

const LegalFooter = () => (
  <footer
    aria-label="Legal links"
    className="fixed inset-x-0 bottom-0 z-50 border-t border-slate-200 bg-white/95 px-4 py-1.5 text-[11px] text-slate-600 backdrop-blur sm:text-xs"
  >
    <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-center gap-x-3 gap-y-1 text-center">
      <span>OncoVectra</span>
      <Link
        className="font-semibold text-blue-700 hover:underline"
        to="/privacy"
      >
        Data policy
      </Link>
      <Link
        className="font-semibold text-blue-700 hover:underline"
        to="/terms"
      >
        Terms and conditions
      </Link>
    </div>
  </footer>
);

export default LegalFooter;
